import { OSTYPE_MNG } from '@/api/apiModules'
export default {
  refreshInterval: false,
  viewType: 'table',
  module: OSTYPE_MNG,
  relationSearch: true,
  sortArr: [
    {
      fieldName: 'osType',
      direction: 'DESC'
    }
  ],
  allowStatus: {},
  toolbar: {
    searchPlaceholder: '请输入操作系统',
    moreBtnWidth: 160,
    searchFieldNameArr: ['osType'],
    hasColAdjustment: true,
    items: [
      {
        slot: 'refresh-rigtht',
        label: 'create',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'osTypeCreate'
      },
      {
        slot: 'refresh-rigtht',
        label: '批量复制',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'osTypeCopyShow'
      }
    ]
  },
  view: {
    columns: [
      {
        props: {
          label: '操作系统',
          prop: 'osType',
          sortField: 'osType'
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime'
        },
        dataType: 'date'
      },
      {
        props: {
          label: '更新时间',
          prop: 'updateTime',
          sortField: 'updateTime'
        },
        dataType: 'date'
      },
      {
        props: {
          showBtnNum: '1',
          fixed: null
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: '编辑',
        command: 'osTypeEdit',
        name: 'OsTypeEdit'
      }
    ]
  }
}
